// extracted by mini-css-extract-plugin
module.exports = {"container":"fileTable_container__zYl2d","tableHeader":"fileTable_tableHeader__3qns-","tableCellTrash":"fileTable_tableCellTrash__3i75r"};